import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ElfsightWidget from '../ElfsightWidget';
import QueriesSection from './QueriesSection';
import ArticleArchive from './ArticleArchive';
import SummaryArchive from './SummaryArchive';
import UserManagement from './UserManagement';
import Locations from './Locations';
import LogoSvg from '../LogoSvg';
import axios from 'axios';

const Admin = ({ authUser, onLogout, isDarkMode }) => {
  const fileInput = useRef();
  const [error, setError] = useState('');
  const [tab, setTab] = useState('summaries');
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();

  const handleFile = async (e) => {
    setError('');
    setUploading(true);
    const file = e.target.files[0];
    if (!file) {
      setUploading(false);
      return;
    }
    const text = await file.text();
    let json;
    try {
      json = JSON.parse(text);
    } catch {
      setError('Invalid JSON file.');
      setUploading(false);
      return;
    }
    if (json.error && json.error.length > 0) {
      setError(json.error);
      setUploading(false);
      return;
    }
    // Remove id fields
    json.articles = json.articles.map(({id, ...rest}) => rest);
    try {
      const res = await axios.post('/api/upload', json);
      if (res.status === 200) {
        setUploading(false);
        // Let child components handle their own refresh
      } else {
        setError('An Error Occurred');
        setUploading(false);
      }
    } catch (err) {
      setError('An Error Occurred');
      setUploading(false);
    }
  };

  return (
    <div className="container mt-5">
      <div className="text-center mb-4">
        <div 
          onClick={() => navigate('/')} 
          style={{ cursor: 'pointer', display: 'inline-block' }}
          title="Go to Landing Page"
        >
          <LogoSvg 
            alt="AECC Logo" 
            className="logo-large"
          />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center">
        <h1>Wire News Digest</h1>
        <div>
          {authUser ? (
            <div className="d-flex align-items-center gap-2">
              <span>Signed in as <strong>{authUser.username}</strong>{authUser.is_admin ? ' (admin)' : ''}</span>
              <button className="btn btn-outline-secondary btn-sm" onClick={onLogout}>Logout</button>
            </div>
          ) : null}
        </div>
      </div>

      {/* Commented out file upload for now */}
      {/* <input type="file" accept="application/json" ref={fileInput} onChange={handleFile} className="form-control mb-3" /> */}
      
      {uploading && (
        <div className="d-flex align-items-center mb-3">
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          <span>Generating Insights...</span>
        </div>
      )}
      
      {error && <div className="alert alert-danger">{error}</div>}
      
      {/* Tab Navigation */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button 
            className={`nav-link${tab === 'summaries' ? ' active' : ''} nav-link-success`}
            onClick={() => setTab('summaries')}
          >
            Summary Archive
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link${tab === 'articles' ? ' active' : ''} nav-link-success`}
            onClick={() => setTab('articles')}
          >
            Article Archive
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link${tab === 'queries' ? ' active' : ''} nav-link-success`}
            onClick={() => setTab('queries')}
          >
            Queries
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link${tab === 'locations' ? ' active' : ''} nav-link-success`}
            onClick={() => setTab('locations')}
          >
            Locations
          </button>
        </li>
        {authUser?.is_admin && (
          <li className="nav-item">
            <button 
              className={`nav-link${tab === 'admin' ? ' active' : ''} nav-link-success`}
              onClick={() => setTab('admin')}
            >
              Users
            </button>
          </li>
        )}
      </ul>

      {/* Tab Content */}
      {tab === 'queries' && <QueriesSection authUser={authUser} isDarkMode={isDarkMode} />}
      {tab === 'summaries' && <SummaryArchive />}
      {tab === 'articles' && <ArticleArchive />}
      {tab === 'locations' && <Locations authUser={authUser} />}
      {tab === 'admin' && <UserManagement authUser={authUser} />}

      <ElfsightWidget />
    </div>
  );
};

export default Admin;